import { createFormAction } from 'redux-form-saga'

const getAccessTokenAction = createFormAction('GET_ACCESS_TOKEN')
const generateAccessTokenAction = createFormAction('GENERATE_ACCESS_TOKEN')

export { getAccessTokenAction, generateAccessTokenAction }
